import React from 'react';
import { Link } from 'react-router';

import logo from 'images/logo-yuanyu-gray.svg';
import omds from 'images/logo-omds-gray.png';

import styles from './index.css';


const Footer = () => (
	<footer className={styles.footer}>
		<div className={styles.content}>
			<div className={styles.contentLeft}>
				<ul>
					<li className={styles.yellow}>
						<a href="http://www.yuanyu.tw/camera/product/dslr/index.php">可換鏡頭式數位相機</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/index.php#anc01">OLYMPUS OM-D</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/index.php#anc02">OLYMPUS PEN</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/index.php#anc04">交換式鏡頭- 4/3系統</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/index.php#anc03">交換式鏡頭-Micro 4/3系統</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/accessory/index.php">配件</a>
					</li>
				</ul>
				<ul>
					<li className={styles.yellow}>
						<a href="http://www.yuanyu.tw/camera/product/compact/index.php">消費型數位相機</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/compact/index.php#anc03">T系列</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/compact/index.php#anc02">配件</a>
					</li>
				</ul>
				<ul>
					<li className={styles.yellow}>
						<a href="http://www.yuanyu.tw/camera/product/software/index.php">軟體及應用程式</a>
					</li>
					<li className={styles.yellow}>
						配件
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/accessory/index.php">單鏡反光相機配件</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/compact/accessory/index.php">消費型數位相機配件</a>
					</li>
				</ul>
				<ul>
					<li className={styles.yellow}>
						歷史機種
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/dslr/record/index.php">單鏡反光相機歷史機種</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/product/compact/record/index.php">消費型數位相機歷史機種</a>
					</li>
				</ul>
			</div>
			<div className={styles.contentRight}>
				<ul>
					<li>
						<a href="http://www.yuanyu.tw/camera/index.php">首頁</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/news.php">最新消息</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/store.php">銷售據點</a>
					</li>
				</ul>
				<ul>
					<li>
						<a href="https://members.yuanyu.tw/course">課程資訊</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/gallery.php">線上藝廊</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/contact.php">聯絡我們</a>
					</li>
					<li>
						<a href="https://shop.yuanyu.tw/" target="_blank" rel="noopener noreferrer">線上購物</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/rohs.php">Environment Information</a>
					</li>
				</ul>
				<ul>
					<li>
						<a href="http://www.yuanyu.tw/">元佑集團首頁</a>
					</li>
					<li>
						<a href="https://www.facebook.com/OlympusTW/" target="_blank" rel="noopener noreferrer">FACEBOOK</a>
					</li>
					<li>
						<a href="https://www.instagram.com/olympus.tw/?hl=zh-tw" target="_blank" rel="noopener noreferrer">INSTAGRAM</a>
					</li>
					<li>
						<Link to="/privacy">隱私權保護條款</Link>
					</li>
				</ul>
			</div>
			<ul className={styles.bottom}>
				<li>
					<a href="https://om-digitalsolutions.com/en/">
						<img src={omds} alt="" style={{ width: '100px', height: 'auto' }} />
					</a>
					<a href="https://www.yuanyu.tw/tw">
						<img src={logo} alt="" style={{ width: '100px', height: 'auto' }} />
					</a>
				</li>
				<li><span role="img" aria-label="C">©</span> 2018 YUANYU Group CO., LTD. All Rights Reserved.</li>
			</ul>
		</div>
	</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/index.js